"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nextRuleName = (existing) => {
    let i = 0;
    let name;
    while (true) {
        if (i < 26) {
            name = String.fromCharCode(65 + i);
        }
        else if (i < 26 * 27) {
            name = String.fromCharCode(64 + Math.floor(i / 26), 65 + (i % 26));
        }
        else if (i < 26 * 27 * 26) {
            name = String.fromCharCode(64 + Math.floor(i / (26 * 26)), 64 + (Math.floor(i / 26) % 26), 65 + (i % 26));
        }
        else {
            name = Math.round(Math.random() * 100000).toString();
        }
        i++;
        if (!existing.find(n => n === name))
            return name;
    }
};
exports.fromOneUpTo = (n) => {
    let arr = [];
    for (let i = 1; i <= n; i++) {
        arr.push(i);
    }
    return arr;
};



// WEBPACK FOOTER //
// ./src/data/util.ts